<template>
  <a-layout :style="{height:layoutHeight+'px'}" class="manager">
    <a-layout-sider :width="130" theme="light">
      <ManagerSider
          ref="managerSider"
          :album="album" :member="member"
          :query-params="params" @search="search"/>
      <a-popover placement="bottomLeft">
        <template slot="content">
          <ShortcutDesc/>
        </template>
        <div style="padding:0 12px;">
          <a-button icon="question-circle" block>操作说明</a-button>
        </div>
      </a-popover>
    </a-layout-sider>
    <a-layout-content>
      <div class="search-form">
        <SearchForm :query-params="params" @click="search"/>
        <ActionBar :album="album" :query-params="params" :selected="selected"
                   @refresh="refresh" @search="search" style="margin-top:15px;"/>
      </div>
      <PhotoList
          ref="photoList" v-model="selected" :with-tags="true"
          :load-func="loadFunc" :album="album" :query-params="params" :decr-width="160"/>
    </a-layout-content>
  </a-layout>
</template>

<script>
import api from "../../../../utils/api";
import func from "../../../../utils/func";
import PhotoList from "./comps/PhotoList";
import ActionBar from "./manager/ActionBar";
import ManagerSider from "./manager/ManagerSider";
import ShortcutDesc from "./comps/ShortcutDesc";
import SearchForm from "./manager/SearchForm";

export default {
  name: "Manager",
  props: ["album", "member"],
  components: {SearchForm, ActionBar, PhotoList, ShortcutDesc, ManagerSider},
  data() {
    return {
      params: {
        release: 0, retouch: 0, unlink: 0,
        raw: 0, top: 0, star: 0, origin: 0,
        time_type: 1, start: 0, finish: 0,
        file_name: "", bib_num: "", member_id: "",
        folder_id: "", order_by: 1,
      },
      selected: [],
      loadFunc: api.v1.album.photo.search,
    }
  },
  computed: {
    layoutHeight() {
      return this.$store.state.layout.clientHeight - 54;
    },
  },
  methods: {
    reset() {
      this.params.raw = 0;
      this.params.top = 0;
      this.params.star = 0;
      this.params.origin = 0;
      this.params.star = 0;
      this.params.finish = 0;
      this.params.unlink = 0;
      this.params.retouch = 0;
      this.params.file_name = "";
      this.params.member_id = "";
      this.params.folder_id = "";
      this.params.release = (this.tabKey === "init") ? 0 : 1;
      this.$refs.photoList.search();
    },
    search() {
      this.$refs.photoList.search();
    },
    refresh(clean) {
      this.$refs.photoList.refresh();
      this.$refs.managerSider.restats();
      if (func.boolStrict(clean)) {
        this.$refs.photoList.clean(true);
      }
    },
  }
}
</script>

<style lang="less" scoped>
.manager {
  padding-top: 3px;

  .ant-layout-sider {
    z-index: 900;
    position: relative;
    box-shadow: 0 1px 5px 5px #dedede;
  }

  .search-form {
    width: 100%;
    z-index: 800;
    position: relative;
    padding: 15px 16px;
    background: #fff;
    box-shadow: 0 1px 5px 5px #dedede;
  }
}
</style>
